import Authentication from '../Authentication';
import * as auth from '../actions/authorizeAction';

const initialState = {
    user: Authentication(),
    error: undefined,
    status: 0
};

const authorize = (state = initialState, action) => {
//    console.log('Reducer', action);
    switch (action.type) {
        case auth.LOGIN_REQUEST:
            return ({
                ...state,
                status: 1
            });
        case auth.LOGIN_SUCCESS:
            return ({
                user: action.loginInfo,
                error: undefined,
                status: 2
            });
        case auth.LOGIN_FAILURE:
            return ({
                user: undefined,
                error: action.error,
                status: 3
            });

        case auth.LOGOUT_REQUEST:
            return ({
                user: undefined,
                error: undefined,
                status: 3
            });

        default:
            return state;
    };
}

export default authorize;
